//client/src/hooks/useBloqueios.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert'; // ✅ CORREÇÃO: Importando o novo hook 'useAlert'.

const BLOQUEIOS_QUERY_KEY = 'bloqueios';

export const useBloqueios = (params, options) => {
    return useQuery({
        queryKey: [BLOQUEIOS_QUERY_KEY, params],
        queryFn: async () => {
            const { data } = await apiClient.get('/bloqueios', { params });
            return data; 
        },
        placeholderData: (previousData) => previousData,
        ...options
    });
};

export const useMutateBloqueios = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert(); // ✅ CORREÇÃO: Usando o novo hook 'useAlert'.

    const invalidateBloqueiosCache = () => {
        queryClient.invalidateQueries({ queryKey: [BLOQUEIOS_QUERY_KEY] });
    };

    const createBloqueio = useMutation({
        mutationFn: (bloqueioData) => apiClient.post('/bloqueios', bloqueioData),
        onSuccess: () => {
            invalidateBloqueiosCache();
            setAlert('Bloqueio criado com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || 'Erro ao criar bloqueio', 'danger'),
    });

    const updateBloqueio = useMutation({
        mutationFn: ({ id, bloqueioData }) => apiClient.put(`/bloqueios/${id}`, bloqueioData),
        onSuccess: () => {
            invalidateBloqueiosCache();
            setAlert('Bloqueio atualizado com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || 'Erro ao atualizar bloqueio', 'danger'),
    });
    
    const deleteBloqueio = useMutation({
        mutationFn: (id) => {
            if (window.confirm('Tem certeza que deseja remover este bloqueio?')) {
                return apiClient.delete(`/bloqueios/${id}`);
            }
            return Promise.reject('Ação cancelada');
        },
        onSuccess: () => {
            invalidateBloqueiosCache();
            setAlert('Bloqueio removido com sucesso!', 'success');
        },
        onError: (err) => {
            if (err !== 'Ação cancelada') {
                setAlert(err.response?.data?.error || 'Erro ao remover bloqueio', 'danger');
            }
        },
    });

    return { 
        createBloqueio, 
        updateBloqueio, 
        deleteBloqueio 
    };
};